import { Language } from '@/shared/types/Settings';

export const RQ_PROJECTS_KEY = ['projects'];
export const RQ_PROJECT_KEY = ['project'];
export const PROJECTS_LIMIT = 23;
export const LS_SPLIT_SEGMENT_MODAL_DISABLED = 'splitSegmentModalDisabled';
export const MAX_TTS_RATING = 5;

export const FOLDERS_LIMIT = {
  desktop: 8,
  laptop: 6,
  largeDesktop: 12,
  mobile: 4,
};

export const AUTODETECT_LANGUAGE_OPTION: Language = {
  id: 'AUTODETECT',
  label: 'Autodetect',
  country_code: '',
  country_label: '',
  is_dialect: false,
  is_free: false,
  is_glossary_available: false,
  is_voice_preset_available: false,
  mean_char_per_syllable: 0,
  speech_rate: 0,
  speech_tempo_feature: false,
  translation_label: null,
  value: 'Autodetect',
  voice_clone: false,
  voice_clone_beta: false,
  voice_clone_label: null,
  voice_preset_dialect: null,
  voice_preset_dialect_label: null,
};
